import React from 'react';
import { getContentstackImageURL } from '@noths/polaris-client-utils';
import type { ImageAspectRatio } from '@noths/polaris-dev-ts-types';

import * as styles from './TextAndImage.styles';

interface Image {
  alt: string;
  src: string;
}

export interface TextAndImageProps {
  body: string;
  heading: string;
  images?: Image[];
  subHeading?: string;
  textColumn?: 'left' | 'right';
}

export const TextAndImage = ({
  body,
  heading,
  images = [],
  subHeading,
  textColumn = 'left',
}: TextAndImageProps) => {
  const imageStyles = [styles.singleImage, styles.twoImages, styles.threeImages];

  const getImageAspectRatio = (index: number, total: number): ImageAspectRatio => {
    if (total === 1) {
      return '4:3';
    }
    if (total === 2) {
      return '3:4';
    }
    return index === 0 ? '16:9' : '1:1';
  };

  const getImageWidth = (index: number, total: number) => {
    if (total === 1) {
      return 800;
    }
    if (total === 2) {
      return 600;
    }
    return index === 0 ? 800 : 400;
  };

  const optimizedImages = images.map((image, index) => ({
    ...image,
    src: getContentstackImageURL(image.src, getImageWidth(index, images.length), {
      aspectRatio: getImageAspectRatio(index, images.length),
    }),
  }));

  return (
    <section css={styles.root({ textColumn })}>
      <div css={styles.textContent}>
        <h2>{heading}</h2>
        {subHeading && <h3>{subHeading}</h3>}
        {body
          .split('\n')
          .filter(Boolean)
          .map((paragraph) => (
            <p key={paragraph}>{paragraph}</p>
          ))}
      </div>
      {optimizedImages.length > 0 && (
        <div css={[styles.imageContainer, imageStyles[images.length - 1]]}>
          {optimizedImages.map((image) => (
            <div key={image.src}>
              <img alt={image.alt} css={styles.image} loading="lazy" src={image.src} />
            </div>
          ))}
        </div>
      )}
    </section>
  );
};
